import { useTranslation } from 'next-i18next';

import React, { useState } from 'react';

import { Box, Button, useSlotRecipe } from '@chakra-ui/react';

import { Prose } from '@nocowanie/common-ui/components/atoms/prose';

import { ListingDescriptionProps } from './listing-description.props';

export const ListingDescription = ({ description }: ListingDescriptionProps) => {
    const { t } = useTranslation('listing', { keyPrefix: 'description' });
    const [open, setOpen] = useState(true);
    const recipe = useSlotRecipe({ key: 'listingLayout' });
    const styles = recipe({});
    const hasMore = description.previewHtml !== null;

    return (
        <Box css={styles.description}>
            <Prose
                dangerouslySetInnerHTML={{
                    __html: open
                        ? description.fullHtml
                        : (description.previewHtml ?? description.fullHtml),
                }}
            />
            {hasMore && (
                <Button
                    css={styles.descriptionButton}
                    variant="link"
                    size="sm"
                    onClick={() => setOpen(value => !value)}
                >
                    {t(open ? 'collapse' : 'expand')}
                </Button>
            )}
        </Box>
    );
};
